import {JetBrainsIcon} from '@github-ui/custom-icons/JetBrainsIcon'
import styles from './CliIcon.module.css'

interface JetBrainsSessionIconProps {
  showConnectedDot?: boolean
}

export function JetBrainsSessionIcon({showConnectedDot = false}: JetBrainsSessionIconProps) {
  const ariaLabel = showConnectedDot ? 'JetBrains session connected' : 'JetBrains session'

  return (
    <span className={styles.wrapper} role="img" aria-label={ariaLabel}>
      <JetBrainsIcon />
      {showConnectedDot && <span data-testid="connected-dot" className={styles.connectedDot} aria-hidden="true" />}
    </span>
  )
}
